<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        title:'何謂放射線治療?',
        videosrc:'R01.mp4',
        list:[
          {
            title:'2分鐘看懂放射治療',
            body:"放射治療乃是運用高能量之游離輻射來破壞癌細胞，防止癌細胞的生長與分裂，而達到控制癌症目的。放射治療是局部治療，只會影響治療區域內細胞，治療時感覺就 像照X光一樣，不會引起任何顯著熱量或電擊感，照射後在體內也不會有任何放射物質存在。"

          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
